import styled from "styled-components";

export const PremiumPubTournamentWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 16px;
  width: 100%;
  border-radius: 8px;
  background: #fff;
`;

export const PremiumPubTournamentHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;

  > .player {
    margin-top: 3px;
    font-weight: 300;
    font-size: 10px;

    > span {
      font-weight: 600;
      font-size: 10px;
    }
  }
`;

export const PremiumPubTournamentHeaderTitle = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;

  > .main {
    font-weight: 700;
    font-size: 15px;
  }

  > .sub {
    font-weight: 400;
    font-size: 11px;
  }
`;

export const PremiumPubTournamentContentWrapper = styled.div`
  display: flex;
  gap: 10px;
  width: 100%;

  > .timer {
    width: 73px;
    height: 73px;
  }
`;

export const PremiumPubTournamentContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;

  > .level {
    font-weight: 600;
    font-size: 20px;
  }
`;

export const PremiumPubTournamentBlindWrapper = styled.div`
  display: flex;
  gap: 5px;
`;

export const PremiumPubTournamentBlind = styled.div<{ isNext: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
  height: 41px;
  border-radius: 8px;
  padding: 7.5px 6px;
  color: ${(p) => (p.isNext ? "#fff" : "#000")};
  background: ${(p) => (p.isNext ? "#D9D9D9" : "#ECF0F3")};

  > .name {
    font-family: Pretendard;
    font-weight: 500;
    font-style: Medium;
    font-size: 8px;
    leading-trim: NONE;
    line-height: 100%;
    letter-spacing: 0%;
  }
  > .value {
    font-family: Pretendard;
    font-weight: 600;
    font-style: SemiBold;
    font-size: 10px;
    leading-trim: NONE;
    line-height: 100%;
    letter-spacing: 0%;
  }
`;

export const PremiumPubTournamentButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
`;

export const PremiumPubTournamentState = styled.div`
  display: flex;
  flex-direction: column;
  font-weight: 600;
  font-size: 10px;
  text-align: center;

  > img {
    width: 31px;
    height: 31px;
  }
`;

export const PremiumPubTournamentButton = styled.div<{
  isOpen: boolean;
  isReservation: boolean;
}>`
  flex: 1;
  height: 35px;
  border-radius: 8px;
  color: #fff;
  text-align: center;
  font-size: 15px;
  font-weight: 600;
  line-height: 35px;
  text-align: center;
  background: ${(p) =>
    p.isReservation
      ? "#D91818"
      : p.isOpen
      ? "var(--Purple-300, rgba(100, 54, 231, 1))"
      : "rgba(217, 217, 217, 1)"};
`;
